import { all } from "redux-saga/effects";
import accountingSlice from "./accounting";
import accountsSlice from "./accounts";
import addOnsSlice from "./addOns";
import brandsSlice from "./brands";
import bulkUploadSlice from "./bulk-upload";
import businessSlice from "./business";
import catalogSlice from "./catalog";
import chargesAndDiscountsSlice from "./chargesAndDiscounts";
import channelMenuSlice from "./channel-menu";
import dashboardSlice from "./dashboard";
import downloadSlice from "./downloads";
import gallerySlice from "./gallery";
import itemSchedulesSlice from "./itemSchedules";
import loginSlice from "./login";
import menusSlice from "./menus";
import outletStatusSlice from "./outlet-status";
import reportsSlice from "./reports";
import taxesSlice from "./taxes";
import commonSlice from "./common";
import inventorySlice from "./inventory";
import recommenderSlice from "./recommender";
import {watchReportsModule,watchInventoryIntegrationLogs,} from "./reportsSaga";
import ristaCardSlice from "./ristaCard";

export default function* root() {
  yield all([
    accountingSlice(),
    accountsSlice(),
    addOnsSlice(),
    brandsSlice(),
    bulkUploadSlice(),
    businessSlice(),
    catalogSlice(),
    channelMenuSlice(),
    chargesAndDiscountsSlice(),
    dashboardSlice(),
    downloadSlice(),
    gallerySlice(),
    itemSchedulesSlice(),
    loginSlice(),
    menusSlice(),
    outletStatusSlice(),
    reportsSlice(),
    taxesSlice(),
    commonSlice(),
    inventorySlice(),
    recommenderSlice(),
    watchReportsModule(),
    watchInventoryIntegrationLogs(),
    ristaCardSlice(),
  ]);
}
